import { useEffect, useState } from "react";
import { Loader2, Search, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

const ALL = "";

export function VigSearch({ onResults }) {
  const [opt, setOpt] = useState({ dipendenti: [], postazioni: [] });
  const [f, setF] = useState({ q: "", dipendente: ALL, postazione: ALL });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api("/local/vig-reports/search-options").then(setOpt).catch(() => {}); }, []);
  const active = f.q.trim() || f.dipendente || f.postazione;
  const search = async (e) => {
    e?.preventDefault();
    if (!active) return toast.error("Scrivi una parola o scegli dipendente o postazione");
    setBusy(true);
    try { const d = await api(`/local/vig-reports/search?${new URLSearchParams(f)}`); onResults(d); }
    catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  const clear = () => { setF({ q: "", dipendente: ALL, postazione: ALL }); onResults(null); };
  const sel = "h-10 rounded-md border border-input bg-white px-3 text-sm";
  return (
    <form onSubmit={search} className="flex flex-wrap items-end gap-3 mb-6" data-testid="vig-search-form">
      <div className="flex-1 min-w-[200px]"><label className="text-xs text-slate-500">Parola</label>
        <Input value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="es. cancello, pescatori, NUE" className="h-10 mt-1 bg-white" data-testid="vig-search-q" /></div>
      <div><label className="text-xs text-slate-500 block">Dipendente</label>
        <select value={f.dipendente} onChange={(e) => setF({ ...f, dipendente: e.target.value })} className={`${sel} mt-1 max-w-[220px]`} data-testid="vig-search-dipendente">
          <option value={ALL}>Tutti</option>{opt.dipendenti.map((n) => <option key={n} value={n}>{n}</option>)}</select></div>
      <div><label className="text-xs text-slate-500 block">Postazione</label>
        <select value={f.postazione} onChange={(e) => setF({ ...f, postazione: e.target.value })} className={`${sel} mt-1`} data-testid="vig-search-postazione">
          <option value={ALL}>Tutte</option>{opt.postazioni.map((n) => <option key={n} value={n}>{n}</option>)}</select></div>
      <Button type="submit" disabled={busy} className="rounded-full bg-[var(--teal)] h-10" data-testid="vig-search-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Search className="w-4 h-4 mr-1" />Cerca in tutti i mesi</>}</Button>
      {active && <Button type="button" variant="ghost" onClick={clear} className="rounded-full h-10" data-testid="vig-search-clear"><X className="w-4 h-4 mr-1" />Azzera</Button>}
    </form>
  );
}
